import { render, staticRenderFns } from "./BandejaLinkPacienteCentroValidacionComponente.vue?vue&type=template&id=3060bd9c&scoped=true"
import script from "./BandejaLinkPacienteCentroValidacionComponente.vue?vue&type=script&lang=js"
export * from "./BandejaLinkPacienteCentroValidacionComponente.vue?vue&type=script&lang=js"
import style0 from "./BandejaLinkPacienteCentroValidacionComponente.vue?vue&type=style&index=0&id=3060bd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060bd9c",
  null
  
)

export default component.exports